<template lang="pug">
.search-result
	.search-result__content
		h3.search-result__title
			a(:href="result.result.url", :target="targetValue") {{ result.result.title }}
			i.search-result__icon(:aria-label="typeLabel", :class="typeIconClass")
		p.search-result__summary <p v-html="result.result.summary" />
</template>

<script>
export default {
	name: "CustomResult",
	props: {
		result: Object
	},
	data() {
		return {
			
		}
	},
	computed: {
		targetValue() {
			return this.result.openInNewWindow ? "_blank" : "";
		},
		typeShort() {
			return this.result.result.contentType.split(".")[1];
		},
		typeLabel() {
			let type;
			switch (this.typeShort) {
				case "BlogDetailPage":
					type = "Blog Detail Page";
					break;
				case "LocationDetailPage":
					type = "Location Detail Page";
					break;
				default:
					type = "Content Page";
			}
			return "This result is a " + type;
		},
		typeIconClass() {
			return "search-result__icon--" + this.typeShort; 
		}
	},
	methods: {
		
	},
	created() {
		
	}
}
</script>

<style lang="scss" scoped>
.search-result {
	padding: 1.5rem 0;
	border-top: 1px solid $mediumGray;
	&__title {
		margin-bottom: 0.375rem;
		a {
			font-size: 1.25rem;
			line-height: 1.1875;
		}
	}
	&__icon {
		font-size: 1.125rem;
		&:after{
			@include fgIcon();
			margin-left: #{$gutterSm*.5};
			// Using as default until we know the service options value
			content: "\e91b";
		}
		&--ContentPage {
			&::after {
				content: "\e91b";
			}
		}
		&--BlogDetailPage {
			&::after {
				content: "\e918";
			}
		}
		&--LocationDetailPage {
			&::after {
				content: "\e907";
			}
		}

		// Unsure of contentType value for service options results
		// &--ServiceOption {
		// 	&::after {
		// 		content: "\e90e";
		// 	}
		// }
	}
	&__summary {
		margin-bottom: 0;
		line-height: 1.4;
	}
}
</style>